import http from '../http';
import Qs from 'qs';
import teachers from './teachers';

// 查询班级树
const getlistClassApi = (params) =>
  http
    .get('/class/listClass', { params })
    .then((res) => res.data);

// 教师考勤-教师考勤
const getschTeaByope = (params) =>
  http.get('/theUserIdentity/sign/sch/tea', { params }).then((res) => res.data);

const setAttendance = (params) =>
  http({
    method: 'put',
    url: `/admin/sign/sch/tea`,
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data);

// 学生请假-学生请假列表
const getLeaveStudentListApi = (params) =>
  http
    .get('/theUserIdentity/leave/listLeaveByCondition', { params })
    .then((res) => res.data);

// 学生请假-学生请假列表-设置退款
const postRefundLeaveApi = (params) =>
  http
    .post(`/theUserIdentity/leave/updateRefund`, Qs.stringify(params), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      errWay: '请假可退款',
      errName: '请假单'
    })
    .then((res) => res.data);

// 同意请假审批
const agreeLeaveSubmitApi = (params) =>
  http
    .post('/theUserIdentity/leave/agreeLeaveAudit', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 删除请假
const deleteLeaveSubmitApi = (params) =>
  http
    .post('/theUserIdentity/leave/deleteLeave', Qs.stringify(params), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
    .then((res) => res.data);

// 驳回请假审批
const disagreeLeaveSubmitApi = (params) =>
  http
    .post('/theUserIdentity/leave/rejectLeaveAudit', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 学生请假详情
const getLeaveFormDetailsApi = (params) =>
  http
    .get('/theUserIdentity/leave/getLeaveDetail', { params })
    .then((res) => res.data);

const getLeaveStudentExcelApi = (params, cancelToken, onDownloadProgress) =>
  http
    .get('/theUserIdentity/leave/exportByCondition', {
      params,
      onDownloadProgress,
      cancelToken,
      responseType: 'blob'
    })
    .then((res) => res);

// 获取sseId（运营端）
const getLeaveTaskIdApi = (params) =>
  http
    .get('/theUserIdentity/classroomStudentLeave/getSseId', { params })
    .then((res) => res.data);

// 学生请假-批量导入
// const leadInLeaveListApi = (params) =>
//   http
//     .get('/theUserIdentity/classroomStudentLeave/batchLeaveStudentImpor', { params })
//     .then((res) => res.data)
const leadInLeaveListApi = (params) =>
  http
    .post(
      `/theUserIdentity/classroomStudentLeave/batchLeaveStudentImport`,
      params,
      {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
    )
    .then((res) => res.data);

// 批量保存请假请假导入数据
const leadInLeaveDataApi = (params) =>
  http
    .post(
      '/theUserIdentity/classroomStudentLeave/batchSaveLeaveStudent',
      params,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    )
    .then((res) => res.data);
// // 驳回请假审批
// const disagreeLeaveSubmitApi = params =>
//   http
//     .post('/theUserIdentity/leave/exportByCondition', params, {
//       headers: { 'Content-Type': 'application/json' }
//     })
//     .then(res => res.data);

// 学生考勤-学生考勤（pc）
const getStudentAttendanceListApi = (params) =>
  http
    .get('/theUserIdentity/sign/sch/studentSign', { params })
    .then((res) => res.data);

// 学生考勤-学生考勤明细（pc）
const getStudentAttendanceDetailsApi = (params) =>
  http
    .get('/theUserIdentity/sign/sch/studentSignInfo', { params })
    .then((res) => res.data);

// 学生考勤-导出学生考勤（pc）
const getStudentAttendanceListExcelApi = (
  params,
  cancelToken,
  onDownloadProgress
) =>
  http
    .get('/theUserIdentity/sign/export/student', {
      params,
      onDownloadProgress,
      cancelToken,
      responseType: 'blob'
    })
    .then((res) => res);

// 学生考勤-导出学生考勤明细（pc）
const getStudentAttendanceDetailsExcelApi = (
  params,
  cancelToken,
  onDownloadProgress
) =>
  http
    .get('/theUserIdentity/sign/export/studentInfo', {
      params,
      onDownloadProgress,
      cancelToken,
      responseType: 'blob'
    })
    .then((res) => res);

// 学生考勤-导出学生考勤明细- 获取任务id
const getStudentAttendanceTaskIdApi = (params) =>
  http.get('/theUserIdentity/sign/getSseId', { params }).then((res) => res.data);

// 学生考勤-导出学生考勤明细- 导出接口
const studentAttanceExportApi = (params) =>
  http
    .get('/theUserIdentity/sign/exportStudentTask', { params })
    .then((res) => res.data);

// 学生考勤-明细-查询未上课节次（pc）2022.06.10解耦需求
const listSchStuSignClasstApi = (params) =>
  http
    .get('/theUserIdentity/courseClassDetail/listSchStuSignClassNo', { params })
    .then((res) => res.data);

// 学生考勤-明细-更新考勤状态（pc）2022.06.10解耦需求
const updateOldClassSignStateApi = (params) =>
  http
    .post(`/theUserIdentity/sign/updateStuAttendanceStatus`, params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 学生考勤-明细-新增考勤状态（pc）2022.06.10解耦需求
const addStuAttendanceStatusApi = (params) =>
  http
    .post(`/theUserIdentity/sign/addStuAttendanceStatus`, params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 学生考勤-明细-查询操作记录（pc）2022.06.10解耦需求
const getOperationListApi = (params) =>
  http
    .get('/theUserIdentity/sign/signActQueryByPage', { params })
    .then((res) => res.data);

// 撤销请假
const cancelLeaveAuditApi = (params) =>
  http
    .post('/theUserIdentity/leave/cancelLeaveAudit', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 通知公告列表
const getqueryNoticeList = (params) =>
  http
    .get('/theUserIdentity/notice/queryNotice', { params })
    .then((res) => res.data);
// 通知公告详情
const getNoticeByNoticeId = (params) =>
  http.get('/notice/queryNoticeByNoticeId', { params }).then((res) => res.data);
// 新增通知公告
const postNoticeSave = (params) =>
  http
    .post('/notice/noticeSave', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 修改通知公告
const postupdate = (params) =>
  http({
    method: 'put',
    url: `/notice/update`,
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data);
// 通知阅读详情接口
const getQueryNoticeRead = (params) =>
  http.get('/notice/queryNoticeReadDetail', { params }).then((res) => res.data);
// 删除通知公告
const delByNoticeId = (params) =>
  http
    .post('/notice/delByNoticeId', Qs.stringify(params), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
    .then((res) => res.data);
// 审核通知接口
const putApproveUpdate1 = (params) =>
  http({
    method: 'put',
    url: `/notice/updateNoticeState`,
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data);
// 阅读详情接口
const getReadDetail = (params) =>
  http.get('/notice/exportNoticeReadDetail', { params }).then((res) => res.data);
// 查看通知的接收对象
const getObjectByNoticeId = (params) =>
  http
    .get('/notice/queryNoticeObjectByNoticeId', { params })
    .then((res) => res.data);
// 批量添加通知对象
const postObjectSaveList = (params) =>
  http
    .post('/notice/objectSaveList', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 去重通知班级人数
const postClassroomNumDistinct = (params) =>
  http
    .post('/notice/classroomNumDistinct', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 系统通知列表
const postListSystemRemind = (params) =>
  http
    .post('/sysStaticDatas/listSystemRemind', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 更新系统通知配置
const updateSystemRemind = (params) =>
  http
    .post('/sysStaticDatas/updateSystemRemind', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 获取系统通知-编辑-学校列表
const getEditSchoolsList = (params) =>
  http.get('/sysSchools/listSchoolsNew', { params }).then((res) => res.data);

// 查询订单结算统计
const getStudentsOrderStatisticsApi = (params) =>
  http
    .get('/theUserIdentity/UserOrder/queryStudentsOrderStatistics', { params })
    .then((res) => res.data);

// 学生订单下的课班列表
const postClassroomReadingStudentApi = (params) =>
  http
    .post('/theUserIdentity/classStudent/pageClassroomReadingStudent', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 请假操作记录
const getLeaveActHistoryApi = (params) =>
  http
    .get('/theUserIdentity/classroomStudentLeave/leaveActQueryByPage', {
      params
    })
    .then((res) => res.data);

// 教师考勤-教师考勤汇总
const getschTeaTotalByope = (params) =>
  http
    .get('/theUserIdentity/sign/sch/tea/total', { params })
    .then((res) => res.data);
// 教师考勤-教师考勤汇总 -  学校端
const getschTeaTotalBySch = (params) =>
  http.get('/sign/sch/tea/total', { params }).then((res) => res.data);

// 教师考勤汇总-查询任课老师
const getSignQueryTea = (params) =>
  http.get('/sign/sch/query/tea', { params }).then((res) => res.data);
// 教师考勤汇总-修改教师考勤
const setSignQueryTea = (params) =>
  http
    .put('/sign/sch/put/tea', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 删除教师考勤记录
const deleteSignTimeTea = (params) =>
  http({
    method: 'put',
    url: '/theUserIdentity/sign/sch/put/tea/clearSignTime',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  }).then((res) => res.data);

// 教师考勤汇总-取消选择教师
const checkSignTimeTea = (params) =>
  http({
    method: 'put',
    url: '/sign/sch/del/tea',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  }).then((res) => res.data);

// 教师考勤汇总列表-补签
const setSignTeaResign = (params) =>
  http
    .put('/theUserIdentity/sign/sch/tea/resign', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 查询系统提醒配置操作日志
const getSysStaticDataRecPage = (params) =>
  http
    .get('/theUserIdentity/sysStaticDatas/sysStaticDataRecPage', { params })
    .then((res) => res.data);

// const putCourseDefine = (params) =>
// http({
//   method: 'put',
//   url: `/courseDefine/publish`,
//   params,
//   headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
// }).then((res) => res.data)
// 批量请假审批
const postBatchLeaveAudit = (params) =>
  http
    .post('/theUserIdentity/leave/batchLeaveAudit', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 批量设置请假可退款
const postBatchChangeLeaveCanRefund = (params) =>
  http
    .post('/theUserIdentity/leave/batchChangeLeaveCanRefund', params, {
      headers: { 'Content-Type': 'application/json' },
      errWay: '请假可退款',
      errName: '请假单'
    })
    .then((res) => res.data);

// 行政班-月考勤纪录
const getClassSignsPerMonthPageApi = (params) =>
  http.get('/theUserIdentity/classroomSign/classSignsPerMonthPage', { params }).then((res) => res.data);

// 行政班-月考勤纪录导出
const exportClassSignsPerMonthApi = (params, cancelToken) =>
  http.get('/theUserIdentity/classroomSign/classSignsPerMonthExport', { cancelToken, params }).then((res) => res.data);

// 课堂反馈分页列表
const getClassroomMienListApi = (params) =>
  http.get('/theUserIdentity/classroomMien/getClassroomMienList', { params }).then((res) => res.data);

// 课堂反馈分页列表导出
const exportClassroomMienListApi = (params, cancelToken, onDownloadProgress) =>
  http
    .get('/theUserIdentity/classroomMien/exportClassroomMienList', {
      params,
      onDownloadProgress,
      cancelToken,
      responseType: 'blob'
    })
    .then((res) => res);

// 教师请假-分页查询
const getTeacherLeavePageApi = (params) =>
  http.get('/theUserIdentity/leave/teacherLeavePage', { params }).then((res) => res.data);

// 批量请假审批（教师）
const postAatchTeacherLeaveAuditApi = (params) =>
  http
    .post('/theUserIdentity/leave/batchTeacherLeaveAudit', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 删除教师请假单
const deleteTeacherLeaveApi = (params) =>
  http.get('/theUserIdentity/leave/deleteTeacherLeave', { params }).then((res) => res.data);

// 请假管理-老师请假-导出
const getTeacherLeaveExportApi = (params, cancelToken, onDownloadProgress) =>
  http
    .get('/theUserIdentity/leave/teacherLeaveExport', {
      params,
      onDownloadProgress,
      cancelToken,
      responseType: 'blob'
    })
    .then((res) => res);

// 教师考勤汇总
const getTeacherSignCollectPageApi = (params) =>
  http.get('/theUserIdentity/sign/teacherSignCollectPage', { params }).then((res) => res.data);

// 教师考勤汇总-导出
const getTeacherSignCollectExportApi = (params, cancelToken, onDownloadProgress) =>
  http
    .get('/theUserIdentity/sign/teacherSignCollectExport', {
      params,
      onDownloadProgress,
      cancelToken,
      responseType: 'blob'
    })
    .then((res) => res);

// 学生请假-批量导入表格解析
// const createBatchLeaveStudentImportTaskApi = (params) =>
//   http
//     .post(`/theUserIdentity/classroomStudentLeave/createBatchLeaveStudentImportTask`, Qs.stringify(params), {
//       headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
//     })
//     .then((res) => res.data);

const createBatchLeaveStudentImportTaskApi = (params) =>
  http
    .post(
      `/theUserIdentity/classroomStudentLeave/createBatchLeaveStudentImportTask`,
      params,
      {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
    )
    .then((res) => res.data);

// 学生请假-获取批量导入解析结果
const getBatchLeaveStudentImportResultApi = (params) =>
  http.get('/theUserIdentity/classroomStudentLeave/getBatchLeaveStudentImportResult', { params }).then((res) => res.data);

// 学生请假-批量保存请假数据
const batchSaveImportLeaveStudentApi = (params) =>
  http
    .post('/theUserIdentity/classroomStudentLeave/batchSaveImportLeaveStudent', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 学校学生考勤消课统计
const getStatisticSchStuSignApi = (params) =>
  http
    .get('/theUserIdentity/sign/sch/statisticSchStuSign', { params })
    .then((res) => res.data);

export default {
  getlistClassApi,
  getschTeaByope,
  setAttendance,
  getLeaveStudentListApi,
  postRefundLeaveApi,
  agreeLeaveSubmitApi,
  deleteLeaveSubmitApi,
  disagreeLeaveSubmitApi,
  getLeaveFormDetailsApi,
  getLeaveStudentExcelApi,
  getLeaveTaskIdApi,
  leadInLeaveListApi,
  leadInLeaveDataApi,
  getStudentAttendanceListApi,
  getStudentAttendanceDetailsApi,
  getStudentAttendanceListExcelApi,
  getStudentAttendanceDetailsExcelApi,
  getStudentAttendanceTaskIdApi,
  studentAttanceExportApi,
  listSchStuSignClasstApi,
  updateOldClassSignStateApi,
  addStuAttendanceStatusApi,
  getOperationListApi,
  cancelLeaveAuditApi,
  getqueryNoticeList,
  getNoticeByNoticeId,
  postNoticeSave,
  postupdate,
  getQueryNoticeRead,
  delByNoticeId,
  putApproveUpdate1,
  postListSystemRemind,
  updateSystemRemind,
  getReadDetail,
  getObjectByNoticeId,
  postObjectSaveList,
  getEditSchoolsList,
  postClassroomNumDistinct,
  getStudentsOrderStatisticsApi,
  postClassroomReadingStudentApi,
  getLeaveActHistoryApi,
  getschTeaTotalByope,
  getschTeaTotalBySch,
  getSignQueryTea,
  setSignQueryTea,
  deleteSignTimeTea,
  checkSignTimeTea,
  setSignTeaResign,
  getSysStaticDataRecPage,
  postBatchLeaveAudit,
  postBatchChangeLeaveCanRefund,
  getClassSignsPerMonthPageApi,
  exportClassSignsPerMonthApi,
  getClassroomMienListApi,
  exportClassroomMienListApi,
  getTeacherLeavePageApi,
  postAatchTeacherLeaveAuditApi,
  deleteTeacherLeaveApi,
  getTeacherLeaveExportApi,
  getTeacherSignCollectPageApi,
  getTeacherSignCollectExportApi,
  createBatchLeaveStudentImportTaskApi,
  getBatchLeaveStudentImportResultApi,
  batchSaveImportLeaveStudentApi,
  getStatisticSchStuSignApi
};
